import axios from "axios";
import { useState } from "react";
import { DAILY_LIFESTYLE_TASKS } from "../../staticData";
import InputField from "../../components/common/inputField";
import ResponseModal from "../../components/generalResponseModal";
import { format } from "date-fns";

const AddTask = ({ memberCode, onClose }) => {
    const [circle, setCircle] = useState('');
    const [taskId, setTaskId] = useState('');
    const [taskName, setTaskName] = useState('');
    const [time, setTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const handleAddTask = async () => {
        console.log({
            memberCode,
            taskId,
            taskName,
            circle,
            action: 'add',
            time,
        });
        try {
            setLoading(true);
            const response = await axios.put(
                `${process.env.REACT_APP_MAIN_SERVICE_BASE_URL}/api/v1/lifestyle`,
                {
                    memberCode,
                    taskId,
                    taskName,
                    circle,
                    action: 'add',
                    time,
                }
            );
            if (response.status === 200) {
                setSuccess(true);
                setLoading(false);
            } else {
                setError(true);
                setLoading(false);
            }
        } catch (error) {
            console.error('Error adding task:', error);
            setLoading(false);
            setError(true);
        }
    };

    const handleChange = (key, value) => {
        switch (key) {
            case 'circle':
                setCircle(value);
                break;
            case 'taskName':
                const selectedTask = DAILY_LIFESTYLE_TASKS.find(task => task.taskId === value);
                if (selectedTask) {
                    setTaskId(selectedTask.taskId);
                    setTaskName(selectedTask.taskName);
                }
                break;
            case 'time':
                const date = new Date(`1970-01-01T${value}:00`);
                const formattedTime = format(date, 'h:mm a').toLowerCase();
                setTime(formattedTime);
                break;
            default:
                console.log('Invalid key');
                break;
        }
    };

    if (loading) {
        return (
            <div className="fixed inset-0 backdrop-blur-sm bg-blend-overlay flex items-center justify-center z-50">
                <div className="bg-black p-4 border rounded-md w-auto">
                    <h2 className="font-bold text-xxl">Adding Task...</h2>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 backdrop-blur-sm bg-blend-overlay flex items-center justify-center z-50">
            <div className="bg-black p-4 border rounded-md w-auto">
                <div className="flex flex-row items-center justify-between">
                    <h2 className="font-bold text-xxl text-white">
                        Add Task
                    </h2>
                    <button
                        className="w-full sm:w-auto border border-gray-300 rounded-md bg-generalButton text-sm py-1 px-2 mb-2 sm:mb-0 sm:mr-2"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
                {!(success || error) && (
                    <div className="flex flex-col items-center justify-between pt-2 text-white">
                        <InputField
                            label="Circle"
                            name="circle"
                            value={circle}
                            onChange={handleChange}
                            options={[
                                { value: 'Morning Circle', label: 'Morning Circle' },
                                { value: 'Afternoon Circle', label: 'Afternoon Circle' },
                                { value: 'Evening Circle', label: 'Evening Circle' },
                            ]}
                            type="dropdown"
                            customClassName="flex flex-row w-4/5 items-center justify-between mb-2 text-white"
                            inputBoxCustomClassName="w-full ml-2 border text-black"
                        />
                        <InputField
                            label="Task"
                            name="taskName"
                            value={taskId}
                            onChange={handleChange}
                            options={DAILY_LIFESTYLE_TASKS.map((task) => ({
                                value: task.taskId,
                                label: task.taskName,
                            }))}
                            type="dropdown"
                            customClassName="flex flex-row w-4/5 items-center justify-between mb-2 text-white"
                            inputBoxCustomClassName="w-full ml-2 border text-black"
                        />
                        <InputField
                            label="Time"
                            name="time"
                            value={time}
                            onChange={handleChange}
                            type="time"
                            placeholder="Enter time (e.g., 10:00)"
                            customClassName="flex flex-row w-4/5 items-center justify-between mb-2 text-white"
                            inputBoxCustomClassName="w-full ml-2 border"
                        />
                        <button
                            className="sm:w-2/5 border border-gray-300 rounded-md bg-generalButton text-sm my-3 py-1 sm:mb-0 sm:mr-2"
                            onClick={handleAddTask}
                            disabled={!taskId || !time || !circle}
                        >
                            Add Task
                        </button>
                    </div>
                )}
                {success && <ResponseModal success={true} message="Task added successfully" close={onClose} />}
                {error && <ResponseModal success={false} message="Failed to add task" close={onClose} />}
            </div>
        </div>
    );
};

export default AddTask;